import {gql} from "@apollo/client";

export const GetMessages = gql`
    query getMessages($userId: Int!) {
        getMessages(userId: $userId) {
            messageId
            messageText
            messageRead
        }
    }
`